import React from "react";
import EditCustomOrderEntry from "./EditCustomOrderEntry";
import { resolveCustomOrderIsQuote } from "../utils/customerLedgerDocTypes";

/** View-only custom order — same UI as edit, loads show API. */
export default function ViewCustomOrder({
  customOrderId,
  onClose,
  masterGoldRate,
  masterSilverRate,
  isQuote,
  docNumber,
}) {
  const resolvedIsQuote =
    isQuote !== undefined && isQuote !== null
      ? Boolean(isQuote)
      : resolveCustomOrderIsQuote(docNumber);

  return (
    <EditCustomOrderEntry
      customOrderId={customOrderId}
      onClose={onClose}
      masterGoldRate={masterGoldRate}
      masterSilverRate={masterSilverRate}
      isQuote={resolvedIsQuote}
      viewOnly
    />
  );
}
